import { render, staticRenderFns } from "./Step6.vue?vue&type=template&id=48d079dc&scoped=true"
import script from "./Step6.vue?vue&type=script&lang=js"
export * from "./Step6.vue?vue&type=script&lang=js"
import style0 from "./Step6.vue?vue&type=style&index=0&id=48d079dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d079dc",
  null
  
)

export default component.exports